const routes = {
  index: {
    path: 'index.consult.wagon',
    url: '/wagon',
  },
  home: {
    path: 'index.consult.wagon.home',
    url: '/accueil',
  },
  edit: {
    path: 'index.consult.wagon.edit',
    url: '/modifier',
  },
  details: {
    path: 'index.consult.wagon.details',
    url: '/details',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/wagon/routes.js